import "./assets/fonts/fonts.css";
import 'vue3-emoji-picker/css'
import {SiweMessage} from "siwe";
import {createApp, h, nextTick, onBeforeUnmount, onMounted, provide, reactive, ref, watch} from "vue";
import {createRouter, createWebHistory, useRoute} from "vue-router";
import App from "./App.vue";
import Axios from "axios";
import Home from "./components/Home.vue";
import Messenger from "./components/Messenger.vue";
import Licences from "./components/Licences.vue";
import Technology from "./components/Technology.vue";
import Breaches from "./components/Breaches.vue";
import About from "./components/About.vue";
import Terms from "./components/Terms.vue";
import Privacy from "./components/Privacy.vue";
import Contact from "./components/Contact.vue";
import Audit from "./components/Audit.vue";
import Docs from "./components/Docs.vue";
import {createPinia} from "pinia";
import {getWeb3} from "./web3.js";
import mitt from "mitt";
import VueClickAway from "vue3-click-away";

const routes = [
        {"component": Home,
            "name": "home",
            "path": "/"},
        {"component": Technology,
            "name": "technology",
            "path": "/technology"},
        {"component": Breaches,
            "name": "breaches",
            "path": "/breaches"},
        {"component": About,
            "name": "about",
            "path": "/about"},
        {"component": Terms,
            "name": "terms",
            "path": "/terms"},
        {"component": Privacy,
            "name": "privacy",
            "path": "/privacy"},
        {"component": Contact,
            "name": "contact",
            "path": "/contact"},
        {"component": Audit,
            "name": "audit",
            "path": "/audit"},
        {"component": Docs,
            "name": "docs",
            "path": "/docs/:section?"},
        {"component": Messenger,
            "name": "messenger",
            "path": "/messenger/:room?"},
        // Administrators only. The page says so and shows nothing else; the
        // routes behind it decide for themselves, so a customer who types the
        // path reaches a page that can tell them nothing.
        {"component": Licences,
            "name": "licences",
            "path": "/licences"}
    ],

    router = createRouter({
        "history": createWebHistory(),
        "mode": "history",
        scrollBehavior () {

            return {"top": 0};

        },
        routes
    }),

    pinia = createPinia();

createApp({

    setup () {

        document.title = process.env.VUE_APP_DOMAIN || "App";

        const serverConfig = reactive({
                "view": "",
                "windowWidth": "",
                "visualMode": "light",
                "chainId": "8453"
            }),
            userInfo = reactive({
                "accounts": [],
                "authorized": false,
                "clientid": "",
                "color_code": "",
                "defaultview": "",
                "email": "",
                "engagement": "",
                "geoIp": "",
                "language": "",
                "networks": [],
                "user_id": "",
                "username": ""
            }),
            eBus = mitt(),
            web3 = ref({}),
            eth = ref({}),
            route = useRoute(),
            profile = ref({}),
            getAccounts = function (callback) {

                if (!web3.value.eth) {

                    return;

                }

                web3.value.eth.getAccounts().
                    then(callback).
                    catch((err) => {

                        console.error(err);

                        if (err.code === 4001) {

                            // EIP-1193 userRejectedRequest error

                        } else {

                            throw err;

                        }

                    });

            },
            requestAccounts = async function () {

                getAccounts(updateAccount);

            },
            updateAccount = async function (accounts) {

                if (accounts.length > 0) {

                    var account = web3.value.utils.toChecksumAddress(accounts[0]);

                    const domain = process.env.VUE_APP_DOMAIN;
                    const origin = process.env.VUE_APP_SERVER_URI;
                    const siweMessage = new SiweMessage({
                      domain,
                      address: account,
                      statement: userInfo.engagement,
                      uri: origin,
                      version: '1',
                      chainId: serverConfig.chainId
                    });
                    const message = siweMessage.prepareMessage();

                    var signature;

                    try {

                        signature = await web3.value.walletClient.signMessage({
                            account,
                            message
                        })

                    } catch (e) {

                        setTimeout(
                            () => {

                                requestAccounts();

                            },
                            1000
                        );

                    }

                    signInAccount(
                        signature,
                        account,
                        message,
                        "metamask"
                    );

                }

            },
            signInAccount = async function (signature, account, message, provider) {

                let ep = "signIn";
                if (userInfo.authorized === true) {

                    ep = "addAccount";

                }

                Axios.get(

                    process.env.VUE_APP_SERVER_URI + ep,
                    {
                        "params": {
                            account,
                            signature,
                            message,
                            provider
                        }
                    }

                ).
                    then((response) => {

                        if (response.status === 200) {

                            getUserInfo();

                        }

                    }).
                    catch((error) => {

                        throw error;

                    });

            },
            getUserInfo = function () {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}getUserInfo`,
                    {
                    }
                ).
                    then((response) => {

                        if (response.data) {

                            for (const i in response.data) {

                                userInfo[i] = response.data[i];

                            }

                        }

                        if (route.query.hl) {

                            userInfo.language = route.query.hl;

                        }

                        if (parseInt(userInfo.user_id)) {

                            getProfile(userInfo.user_id);

                        }

                    }).
                    catch((error) => {

                        throw error;

                    });

            },
            getNetwork = function () {

                web3.value.eth.getChainId().
                    then((chainId) => {

                        serverConfig.chainId = parseInt(chainId);

                        eth.value.request({
                            "method": "wallet_switchEthereumChain",
                            "params": [{"chainId": web3.value.utils.toHex(serverConfig.chainId)}]
                        });

                        setServerConfig(chainId);

                    });

            },
            setNetwork = async function (id) {

                if (!id) {

                    id = localStorage.getItem("selectedChainId");

                    if (!id) {

                        id = '8453';

                    }

                } else {

                    localStorage.setItem(
                        "selectedChainId",
                        id
                    );

                }

                setServerConfig(id);

                if (eth.value) {

                    try {

                        eth.value.request({
                            "method": "wallet_switchEthereumChain",
                            "params": [{"chainId": web3.value.utils.toHex(parseInt(id))}]
                        });

                    } catch (e) {

                        if (id == "8453") {

                            await eth.value.request({
                                "method": "wallet_addEthereumChain",
                                "params": [
                                    {"chainId": web3.value.utils.toHex("8453"),
                                        "rpcUrls": ["https://mainnet.base.org"],
                                        "chainName": "Base Mainnet",
                                        "nativeCurrency": {
                                            "name": "Base",
                                            "symbol": "ETH",
                                            "decimals": 18
                                        },
                                        "blockExplorerUrls": ["https://basescan.org/"]}
                                ]
                            });

                        }

                    }

                    getNetwork();

                } else {

                    serverConfig.chainId = id;

                }

            },
            setServerConfig = function (chainId) {

                serverConfig.VUE_APP_CHAIN_ID = process.env.VUE_APP_BASE_CHAIN_ID;
                serverConfig.VUE_APP_PROVIDER = process.env.VUE_APP_BASE_PROVIDER;

            },
            getProfile = function (user_id) {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}getProfile`,
                    {

                        "params": {

                            userId:user_id

                        }

                    }
                ).
                    then((response) => {

                        if (response.status === 200) {

                            if (response.data) {

                                profile.value = response.data;

                            }

                        }

                    });

            },
            onResize = function () {

                const windowWidth = window.innerWidth;
                serverConfig.windowWidth = windowWidth;

                if (windowWidth >= 1024) {

                    serverConfig.view = "desktop";

                } else if (windowWidth >= 750) {

                    serverConfig.view = "tablet";

                } else {

                    serverConfig.view = "mobile";

                }

            };

        onMounted(() => {

            const savedTheme = localStorage.getItem("enbarr-theme") || "light";
            serverConfig.visualMode = savedTheme;
            if (savedTheme === "dark") {
                document.documentElement.setAttribute("data-theme", "dark");
            }

            window.open = (function (open) {

                return function (url, name, features) {

                    name ||= "default_window_name";
                    return open.call(
                        window,
                        url,
                        name,
                        features
                    );

                };

            }(window.open));

            watch(
                () => userInfo.networks,
                () => {

                    getNetwork();

                }
            );

            setServerConfig(serverConfig.chainId)

          /*
            getWeb3({
                "VUE_APP_INFURA_ID": process.env.VUE_APP_INFURA_ID,
                "VUE_APP_PROVIDER": serverConfig.VUE_APP_PROVIDER
            }).then(async ({w3,ethereum}) => {

                web3.value = w3;
                eth.value = ethereum;

                if (ethereum) {

                    const getAccounts = await ethereum
                        .request({ method: "eth_requestAccounts" })
                        .then((response) => {console.log(response)})
                        .catch((err) => {
                          console.log(err);
                        });

                    eth.value.on(
                        "accountsChanged",
                        (accounts) => {

                            userInfo.accounts = accounts;

                        }
                    );
                    eth.value.on(
                        "chainChanged",
                        (networks) => {

                            userInfo.networks = networks;

                        }
                    );

                }

                setNetwork();

            });
            */

            eBus.on(
                "app-event",
                (e) => {

                    switch (e.action) {

                    case "getUserInfo":
                        getUserInfo();
                        break;
                    case "setNetwork":
                        setNetwork(e.data);
                        break;
                    case "getWeb3":
                        getWeb3({
                            "VUE_APP_INFURA_ID": process.env.VUE_APP_INFURA_ID,
                            "VUE_APP_PROVIDER": serverConfig.VUE_APP_PROVIDER
                        }).then(async ({w3,ethereum}) => {

                            if (ethereum) {

                                const getAccounts = await ethereum
                                    .request({ method: "eth_requestAccounts" })
                                    .then((response) => {console.log(response)})
                                    .catch((err) => {
                                      console.log(err);
                                    });

                            }

                            web3.value = w3;
                            eth.value = ethereum;

                            if (e.data == "login") {

                                requestAccounts();

                            }

                        });
                        break;
                    default:
                        break;

                    }

                }
            );
            nextTick(() => {

                window.addEventListener(
                    "resize",
                    onResize
                );
                onResize();
                getUserInfo();

            });

        });
        onBeforeUnmount(() => {

            window.removeEventListener(
                "resize",
                onResize
            );

        });
        provide(
            "eBus",
            eBus
        );
        provide(
            "router",
            router
        );
        provide(
            "route",
            route
        );
        provide(
            "web3",
            web3
        );
        provide(
            "eth",
            eth
        );
        provide(
            "userInfo",
            userInfo
        );
        provide(
            "profile",
            profile
        );
        provide(
            "serverConfig",
            serverConfig
        );
        return {eBus,
            getUserInfo,
            getAccounts,
            requestAccounts,
            updateAccount,
            signInAccount,
            onResize,
            route,
            serverConfig,
            userInfo,
            profile,
            getProfile,
            getNetwork,
            setNetwork,
            setServerConfig,
            web3,
            eth};

    },
    render () {

        return h(App);

    }
}).
    use(pinia).
    use(VueClickAway).
    use(router).
    mount("#app");
